import React, {useEffect} from 'react'
import {Col, Row} from 'react-bootstrap'
import ByondGrid2 from "../../../../customGrid/CustomGrid";
import {AlertStockLevelGridTemplate} from './AlertStockLevelGridTemplate';

const mapToFriendlyName = (data) => {
  if (!data) {
    return 'Sem dados';
  }
  return data.map(x => <li key={x.id}>{x.friendlyName}</li>);
}

function StockLevelCriticDetailType({data, setCurrentDetailType}) {

  if (!data) {
    return 'Sem dados';
  }

  const templateGrid = new AlertStockLevelGridTemplate(data);

  useEffect(() => {
    if (!data) {
      return
    }
    setCurrentDetailType({
      metadata: templateGrid,
      endpoint: templateGrid.endpoint()
    })
  }, [data])

  return (
    <React.Fragment>
      <Row>
        <Col md={6} className="mt-4">
          <h4 style={{fontWeight: 'bold'}}>Tipo(s) de Produto(s):</h4>
          <ul> {mapToFriendlyName(data.alertConfiguration.productTypes)}</ul>
        </Col>
        <Col md={6} className="mt-4">
          <h4 style={{fontWeight: 'bold'}}>Local/Locais:</h4>
          <ul> {mapToFriendlyName(data.alertConfiguration.bizLocations)}</ul>
        </Col>
      </Row>
      <Row className="mb-5">
        <Col md={6} className="d-flex mt-5">
          <h4 style={{fontWeight: 'bold'}}>Quantidade mínima: &nbsp;</h4>
          <span>{data.alertConfiguration.minValue}%</span>
        </Col>
        <Col md={6} className="d-flex mt-5">
          <h4 style={{fontWeight: 'bold'}}>Quantidade máxima: &nbsp;</h4>
          <span>{data.alertConfiguration.maxValue}%</span>
        </Col>
      </Row>
      <Col md={12}>
        <ByondGrid2 endpoint={templateGrid.endpoint()} metadata={templateGrid} removeBox/>
      </Col>
    </React.Fragment>
  )
}

export {StockLevelCriticDetailType}



// WEBPACK FOOTER //
// ./src/pages/Alerts/CustomAlert/StockLevelAlert/StockLevelDetailType.js